import { SessionData, SessionDataVersion, ConfigurationDelta } from "./types";

const _migrationsByVersion: {
	[key in SessionDataVersion]?: (s: ConfigurationDelta) => ConfigurationDelta;
} = {
	//
};

export const migrateToLatest = (sessionData: SessionData): SessionData => {
	return sessionData;
};
